import React from 'react'
import { motion } from 'framer-motion'
import { Link } from 'react-router-dom'

function Registration() {
  return (
    <div className="container">
        <motion.div className="card shadow-lg" style={{ overflow: 'hidden', background: 'None' }}
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                whileHover={{ scale: 1.05 }}
                transition={{ duration: 0.6, ease: 'easeOut' }}>
                    <div className="card-body">
                        <h1 className="card-title text-center text-danger"><strong>Registration</strong></h1>

                        <h4 className="card-title text-danger my-5">Kindly do the needful accordingly for registration:</h4>

                        <ul className='my-5'>
                          <li>
                            <p className="card-text" style={{textAlign:"justify"}}>Check your CMT registered email ID for acceptance.</p>
                          </li>

                          <li>
                            <p className="card-text my-3" style={{textAlign:"justify"}}>Need to check the comments of reviewers for improvement of the paper.</p>
                          </li>

                          <li>
                            <p className="card-text my-3" style={{textAlign:"justify"}}>Update the paper accordingly and prepare the final camera-ready copy (CRC), check the author's details, emails, organization, figures visibility, References, results X-axis name and Y-axis name etc. and give the name "CRC_PID" to file. It should be doc/docx file only.</p>
                          </li>

                          <li>
                            <p className="card-text my-3" style={{textAlign:"justify"}}>Do the payment according to the category of registration and write "For JNU NETCRYPT" in the payment reference (during the payment process).  Take a copy of payment slip in PDF or JPEG or PNG. Give the name Payment_PID to file.</p>
                          </li>

                          <li>
                            <p className="card-text my-3" style={{textAlign:"justify"}}>Fill out the registration form for the presentation. All information needs to be verified twice.  NAME, MOBILE, WHATSAPPS NO, email ID, Payment Details.</p>
                          </li>

                          <li>
                            <p className="card-text my-3" style={{textAlign:"justify"}}>Wait for the paper presentation schedule. Check your email or Conference Website. The registration fee for IEEE and Non-IEEE authors are as follows.</p>
                          </li>
                        </ul>

                        {/* <h4 className="card-title text-danger my-3">CRC Registration for Authors</h4>
                        
                        <ul>

                        <li>
                        <p className="card-text" style={{textAlign:"justify"}}>Authors are requested to complete the Camera-Ready Copy (CRC) registration using the form provided below.</p>
                        </li>

                        <li>
                        <p className="card-text" style={{textAlign:"justify"}}>Please ensure that all required details are filled in correctly before submitting the form.</p>
                        </li>

                        <a href="YOUR_CRC_FORM_LINK"
                        target="_blank"
                        style={{display: "inline-block", padding: "12px 25px", background: "#2c3e50", color: "#ffffff", textDecoration: "none", fontWeight: "bold", borderRadius: "6px", margin: "15px 0" }}>
                          👉 CRC Registration Form
                        </a>

                        <a href="https://forms.gle/V74GmPUrjyyeBE8e7" target="_blank" className="btn btn-outline-danger my-4"> <h6>👉 CRC Registration Form</h6> </a>
                        
                        <li>
                        <p className="card-text" style={{textAlign:"justify"}}>For any queries or issues regarding the CRC registration process, please contact us at netcrypt2026@gmail.com.</p>
                        </li>

                        </ul> */}

                        <h4 className="card-title text-danger my-3">Registration fees</h4>
                <p className="card-text" style={{textAlign:"justify"}}>The registration fees cover the cost of food and beverages, a bag, a brochure, schedules, a pen, and a note pad.</p>


                <div className="container table-responsive">
                <table className="table table-hover">
                    <thead>
                      <tr>
                        <th scope="col"> </th>
                        
                          <th scope="col"><p>Indian</p></th>
                          <th scope="col"><p>International</p></th>                     
                  
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <th scope="row"><p>Non-IEEE Professional (Authors)</p></th>
                        
                        <td>&#8377; 12,550 </td>
                        <td>&#x24; 350 </td>
                   
                      </tr>

                      <tr>
                        <th scope="row">  IEEE Professional Members (Authors)</th>
                        
                        <td>&#8377; 10,050</td>
                        <td>&#x24; 280 </td>
                        
                        
                        
                      </tr>

                      <tr>
                        <th scope="row">Non-IEEE Students (Authors)</th>
                        
                        <td>&#8377; 8550</td>
                        <td>&#x24; 200 </td>
                  
                        
                        
                      </tr>

                      <tr>
                        <th scope="row">  IEEE Student Members (Authors)</th>
                        
                        
                        <td>&#8377; 6550</td>
                        <td>&#x24; 160 </td>
                      
                        
                        
                      </tr>

                      {/* <tr>
                        <th scope="row">Co-Author</th>
                        
                        
                        <td>&#8377; 1298</td>
                        <td>&#x24; 30 </td>
                      </tr> */}

                      <tr>
                        <th scope="row">Attendees and Poster Presenter</th>
                        
                        <td>&#8377; 2050</td>
                        <td>&#x24; 40 </td>
                      </tr>

                    </tbody>
                </table>
                </div>

                <h3 className="card-title text-danger">Important Note</h3>

                <ul className='my-5'>
                  <li>
                    <p className="card-text my-3" style={{textAlign:"justify"}}>In no case organizing institute or any of the organizing team members will be responsible, <strong>if the article is rejected at any phase due</strong> to quality issues, before or after acceptance.</p>
                  </li>

                  <li>
                    <p className="card-text my-3" style={{textAlign:"justify"}}>Additionally, please note that in order to promote offline presentations, only presenters <strong>who are presenting offline will be provided with the kit.</strong></p>
                  </li>
                  {/* <li>
                    <p className="card-text" style={{textAlign:"justify"}}>Registrations after the deadline will incur an <strong>additional fee of ₹1000 for Indian participants and $10 for international participants.</strong> </p>
                  </li> */}
                </ul>


                <h3 className="card-title text-danger">For Least Developed Countries (LDCs)</h3>

                <ul>
                  <li>
                    <h5 className="card-title my-2" style={{"textAlign":"justify"}}>Authors from Least Developed Countries (LDCs) may be eligible for special discounts on registration fees based on their economic conditions.</h5>

                  </li>

                  <li>
                    <h5 className="card-title border-bottom" style={{"textAlign":"justify"}}>Authors from Least Development Countries (LDCs) are required to send an email to chair@netcrypt.org.in to request for the special discount.</h5>

                  </li>
                </ul>
                  
                <h3 className="card-title text-danger my-5">Bank Details</h3>

                <div class="row row-cols-1 row-cols-md-2 g-4">
                  <div class="col">
                    <div class="card h-100 shadow">
                      <div class="card-body">
                        <h5 class="card-title text-danger">Account Details for Indian Authors</h5>
                        <table className="table table-striped table-hover my-2">
                            <thead>
                              <tr>
                                <th scope="col"> </th>
                                {/* <th scope="col">Non IEEE Member</th> */}
                                
                          
                              </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <th scope="row">Beneficary Name</th>
                                <td>JNU SPONSORED PROJECT A/c</td>
                                
                              </tr>

                              <tr>
                                <th scope="row">  Name of Bank</th>
                                <td>STATE BANK OF INDIA</td>
                                
                              </tr>

                              <tr>
                                <th scope="row">Branch Name</th>
                                <td>JNU, NEW CAMPUS</td>
                                
                              </tr>

                              <tr>
                                <th scope="row">Account Number</th>
                                <td>10596550879</td>
                                
                              </tr>

                              <tr>
                                <th scope="row">  IFSC Code</th>
                                <td>SBIN0010441</td>
                                
                              </tr>

                              <tr>
                                <th scope="row">Bank Branch MICR Code</th>
                                <td>110002428</td>
                                
                              </tr>

                              <tr>
                                <th scope="row">  Complete address</th>
                                <td>JNU New Campus Branch near Godavari Hostel, JNU, New Delhi-110067</td>
                                
                              </tr>
               
                            </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div class="col">
                    <div class="card h-100 shadow">
                      <div class="card-body">
                        <h5 class="card-title text-danger">Account Details for Foreign Authors</h5>
                        <table className="table table-striped table-hover my-2">
                            <thead>
                              <tr>
                                <th scope="col"> </th>
                                {/* <th scope="col">Non IEEE Member</th> */}
                                
                          
                              </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <th scope="row">INSTITUTIONS'S ACCOUNT Name</th>
                                <td>JNU SPONSORED FELLOWSHIP/SCHOLARSHIP A/c</td>
                                
                              </tr>

                              <tr>
                                <th scope="row">  Name of Bank</th>
                                <td>STATE BANK OF INDIA</td>
                                
                              </tr>

                              <tr>
                                <th scope="row">Branch Name</th>
                                <td>JNU, NEW CAMPUS</td>
                                
                              </tr>

                              <tr>
                                <th scope="row">Account Number</th>
                                <td>10596551089</td>
                                
                              </tr>

                              <tr>
                                <th scope="row">  IFSC Code</th>
                                <td>SBIN0010441</td>
                                
                              </tr>

                              <tr>
                                <th scope="row">SWIFT Code</th>
                                <td> <strong>SBININBB548</strong> </td>
                                
                              </tr>

                              <tr>
                                <th scope="row">Bank Branch MICR Code</th>
                                <td>110002428</td>
                                
                              </tr>

                              <tr>
                                <th scope="row">  Complete address</th>
                                <td>JNU New Campus Branch near Godavari Hostel, JNU, New Delhi-110067</td>
                                
                              </tr>
 
                            </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  
                </div>
                        
                </div>
                </motion.div>
    </div>
  )
}

export default Registration